module.exports = "/Users/modetojoy/work/10gen/compass-server-version/lib/assets/images/fontawesome-webfont__2JcyC.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 16
// module chunks = 0